import React, { useState } from 'react';
import moment from 'moment';

function Clock() {
    const sdf = 'LTS';
    let time = moment().format(sdf);
    const [cTime, setNewTime] = useState(time);
    const updateTime = () => {
        time = moment().format(sdf);
        setNewTime(time);
    }
    setInterval(updateTime, 1000);
    return <h4>{cTime}</h4>
}

export default Clock;